<template>
	<Accordion>
		<AccordionItem label="Initial greeting" :error="!exists('greeting')">
			<p>
				A greeting message that will be shown to the user when when they first
				load the page.
			</p>
			<DialogueEditor v-model="value.value.greeting" />
		</AccordionItem>
		<AccordionItem
			start-open
			label="Campaign intro"
			:error="!exists('question')"
		>
			<p>
				Shown when the user visits the homepage.
			</p>
			<DialogueEditor v-model="value.value.question" />
		</AccordionItem>
		<AccordionItem label="LED wall idle" :error="!exists('wall_idle')">
			<p>Things to say intermittently on the wall display.</p>
			<DialogueEditor v-model="value.value.wall_idle" />
		</AccordionItem>
		<AccordionItem
			label="LED wall interaction"
			:error="!exists('wall_interact')"
		>
			<p>Shown when the wall display first detects user input.</p>
			<DialogueEditor v-model="value.value.wall_interact" />
		</AccordionItem>
		<AccordionItem label="Submission form" :error="!exists('submit')">
			<p>Shown when a user loads the submission form.</p>
			<DialogueEditor v-model="value.value.submit" />
		</AccordionItem>
		<AccordionItem label="Submission successful" :error="!exists('submitted')">
			<p>Shown after a user succesfully submits an idea.</p>
			<DialogueEditor v-model="value.value.submitted" />
		</AccordionItem>
		<AccordionItem label="Finished voting" :error="!exists('voted')">
			<p>Shown at the end of a voting session.</p>
			<DialogueEditor v-model="value.value.voted" />
		</AccordionItem>
		<AccordionItem label="Leaderboard" :error="!exists('leaderboard')">
			<p>
				Shown when a user loads the leaderboard, and there's at least one
				leaderboard item.
			</p>
			<DialogueEditor v-model="value.value.leaderboard" />
		</AccordionItem>
		<AccordionItem
			label="Leaderboard (empty)"
			:error="!exists('leaderboard_empty')"
		>
			<p>
				Shown when a user loads the leaderboard and there's nothing on it yet.
			</p>
			<DialogueEditor v-model="value.value.leaderboard_empty" />
		</AccordionItem>
		<AccordionItem label="Gallery" :error="!exists('gallery')">
			<p>
				Shown when a user views the gallery, and there's at least one
				submission.
			</p>
			<DialogueEditor v-model="value.value.gallery" />
		</AccordionItem>
		<AccordionItem label="Gallery (empty)" :error="!exists('gallery_empty')">
			<p>
				Shown when a user loads the gallery but there are no submissions to
				show.
			</p>
			<DialogueEditor v-model="value.value.gallery_empty" />
		</AccordionItem>
	</Accordion>
</template>

<script>
import Accordion from '@/components/admin/Accordion'
import AccordionItem from '@/components/admin/AccordionItem'
import DialogueEditor from '@/components/admin/DialogueEditor'

import { lib } from 'protoswipe-shared'
const { dialogue } = lib

export default {
	name: 'DialogueForm',
	props: {
		value: Object
	},
	methods: {
		exists(key) {
			const trimmed = dialogue.reduce(this.value.value)
			return trimmed && trimmed.hasOwnProperty(key)
		}
	},
	components: {
		Accordion,
		AccordionItem,
		DialogueEditor
	}
}
</script>
